module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "video"
    }
  }, [_c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs')], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.nowTitle,
      "class-name": "vertical-center-modal-video"
    },
    model: {
      value: (_vm.modalvideo),
      callback: function($$v) {
        _vm.modalvideo = $$v
      },
      expression: "modalvideo"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f60",
      "text-align": "center",
      "margin": "0"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('iframe', {
    attrs: {
      "width": "560",
      "height": "315",
      "src": _vm.nowVideo,
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })]), _vm._v(" "), (!_vm.$route.meta.keepAliveSub) ? _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_two"
  }, [_c('div', {
    staticClass: "tea_r_l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchName),
      expression: "searchName"
    }],
    staticClass: "psear_input",
    attrs: {
      "name": "",
      "type": "text",
      "placeholder": _vm.showPage.videoSearch
    },
    domProps: {
      "value": (_vm.searchName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "gue_btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v(_vm._s(_vm.showPage.search))])]), _vm._v(" "), _c('div', {
    staticClass: "tea_r_r"
  }, [_c('span', {
    staticClass: "ca2_btn"
  }, [_vm._v(_vm._s(_vm.showPage.orderByReleaseDate))])]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _vm._l((_vm.videos), function(video, index) {
    return (_vm.inCurrentPage(index)) ? _c('div', {
      key: index,
      staticClass: "photo_box",
      on: {
        "click": function($event) {
          _vm.selectVideo(video)
        }
      }
    }, [_c('div', {
      staticClass: "photo_box_pic"
    }, [_c('img', {
      attrs: {
        "src": video.coverPictureUrl
      }
    })])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "pagination-row text-center ml20"
  }, [_c('Page', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "current": _vm.currentPage,
      "total": _vm.videos.length,
      "page-size": _vm.pagesize
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)], 2)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-91759b8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Video.vue
// module id = 1276
// module chunks = 4